import React from 'react';
import { motion } from 'framer-motion';
export function CostOfInaction() {
  const costs = [{
    without: 'El costo de tu tiempo',
    cost: '6 meses más de ensayo y error.'
  }, {
    without: 'El costo de tu ego',
    cost: 'Seguir sintiendo que otro es mejor.'
  }, {
    without: 'El costo de tu soledad',
    cost: 'Otro domingo frente a la pantalla.'
  }];
  return <section className="py-24 md:py-32 px-4 bg-bg-primary" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-4 text-center" data-id="element-58">
          ⚖️ ¿Cuál es el costo de no hacer nada?
        </motion.h2>
        <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-14" data-id="element-59" />

        <div className="overflow-x-auto mb-16 rounded-xl border border-border-subtle" data-id="element-60">
          <table className="w-full min-w-[500px]" data-id="element-61">
            <tbody data-id="element-62">
              {costs.map((cost, i) => <motion.tr key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className={`${i % 2 === 0 ? 'bg-bg-card' : 'bg-bg-row-alt'} border-b border-border-divider last:border-0`} data-id="element-63">
                  <td className="p-6 text-text-secondary text-base w-1/2" data-id="element-64">
                    {cost.without}
                  </td>
                  <td className="p-6 text-text-primary font-medium text-base w-1/2 border-l border-border-divider" data-id="element-65">
                    {cost.cost}
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-gold font-display text-2xl md:text-3xl font-bold text-center" data-id="element-66">
          El próximo fin de semana puede ser diferente.
        </motion.p>
      </div>
    </section>;
}